<template>
  <div class="lottie-spinner-overlay
    is-flex is-align-items-center is-justify-content-center is-flex-direction-column">
    <div ref="lottie"
      class="lottie-spinner" />
    <div class="has-text-white mt-1">{{ message }}</div>
  </div>
</template>
<script>

import lottie from 'lottie-web'
import animationData from '@/assets/json/spinner.json'

export default {
  props: {
    message: {
      type: String,
      default: 'Loading...'
    }
  },
  mounted() {
    lottie.loadAnimation({
      container: this.$refs.lottie,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData
    })
  }
}
</script>

<style lang="scss" scoped>
.lottie-spinner-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.lottie-spinner {
  width: 128px;
  height: 128px;
}
</style>
